import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ 'input', 'element' ]
  static values = {
    present: { type: Boolean, default: true }
  }

  connect() {
    this.toggle()
  }

  inputTargetConnected(target) {
    this.toggle()
    target.addEventListener('input', () => { this.toggle() })
  }

  inputTargetDisconnected(_target) {
    this.toggle()
  }

  toggle() {
    if (this.matchesInput() || this.elementTarget.querySelector('.field_with_errors')) {
      this.elementTarget.classList.remove('hidden')
    } else {
      this.elementTarget.classList.add('hidden')
    }
  }

  hasValue(input) {
    if (input.type === 'checkbox' || input.type === 'radio') {
      return input.checked
    } else {
      return input.value.trim() !== ''
    }
  }

  matchesInput() {
    if (this.presentValue) {
      return this.inputTargets.some((input) => this.hasValue(input))
    } else {
      return this.inputTargets.every((input) => !this.hasValue(input))
    }
  }
}
